import { useState } from 'react';

import { SqlModal } from '@/_shared/components/SqlModal';

import { ReadOnlyClause } from './ReadOnlyClause';
import type { RawSqlPredicate } from './types';

/** The raw-SQL escape hatch, rendered read-only (Law A — degrade, never block): the plain-language `sentence`
 *  in a plain bordered box, with a "Show SQL" icon button (in the row-actions group) that opens the verbatim
 *  SQL in a modal (highlighted, copyable). No edit controls — it round-trips untouched; `onRemove` drops it.
 *  The sentence and the SQL viewer are never greyed on `disabled` (viewing is non-mutating); only the delete
 *  is gated. */
export function RawSqlClause({
  predicate,
  onRemove,
  disabled = false,
  onShowSql,
}: {
  predicate: RawSqlPredicate;
  onRemove?: () => void;
  disabled?: boolean;
  /** Reported when the SQL opens. The fragment itself is never passed on. */
  onShowSql?: () => void;
}) {
  const [sqlOpen, setSqlOpen] = useState(false);
  return (
    <>
      <ReadOnlyClause
        text={predicate.sentence}
        onShowSql={() => {
          setSqlOpen(true);
          onShowSql?.();
        }}
        onRemove={onRemove}
        disabled={disabled}
      />
      <SqlModal
        open={sqlOpen}
        onOpenChange={setSqlOpen}
        sql={predicate.sql}
        title="Raw SQL"
        description="This clause is defined as raw SQL and isn't editable in the visual builder."
      />
    </>
  );
}
